var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a"},[_c('Nav'),_c('PageBannerBig',{attrs:{"banner":_vm.banner}}),_c('Solution'),_c('Contact'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }